export const skillCategories = {
  Frontend: [
    "React",
    "Angular",
    "JavaScript",
    "TypeScript",
    "HTML",
    "CSS",
    "SCSS",
    "Tailwind",
    "Vite",
  ],
  Backend: ["Python", "Java", "C#", "Node.js", "SQL"],
  "Tools & DevOps": [
    "AI",
    "Cursor",
    "OpenRouter",
    "LLM APIs",
    "Ageentic Workflows",
    "Git",
    "AWS",
    "Azure",
    "CI/CD",
  ],
  "Cloud Resources": [
    "Bedrock",
    "Docker",
    "MongoDB",
    "SQL",
    "DocumentDB",
    "S3",
    "DynamoDB",
  ],
  Leadership: [
    "Technical Leadership",
    "Team Organization",
    "Mentorship",
    "Decision Making",
  ],
  Collaboration: [
    "Customer Facing",
    "Product Discovery",
    "Stakeholder Communication",
    "Cross-Functional Work",
  ],
};
